module.exports = __webpack_public_path__ + "static/media/send-up.65ef642b.svg";